<template>
    <Layout>
        <PageHeader :title="title" :items="items"></PageHeader>
        <div class="row" id="gmb">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row align-items-center mb-4">
                            <div class="col-md-3 mb-2 mb-md-0">
                                <div class="form-inline navbar-search">
                                    <div class="input-group">
                                        <input
                                            class="form-control bg-light border-0 small"
                                            placeholder="Search Business Name"
                                            v-model="filter"
                                            @input="onSearchInput"
                                        />
                                        <div class="input-group-append">
                                        <button class="btn btn-search" @click="searchFor">
                                            <i class="fas fa-search fa-sm"> </i>
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 mb-2 mb-md-0">
                                <multiselect
                                    v-model="cityFilter"
                                    :options="cityOptions"
                                    track-by="value"
                                    label="text"
                                    :multiple="false"
                                    placeholder="Search City"
                                    @input="onFilterChange"
                                >
                                    <span slot="noResult">No city found</span>
                                </multiselect>
                            </div>
                            <div class="col-md-3 mb-2 mb-md-0">
                                <multiselect
                                    v-model="specialityFilter"
                                    :options="specialityOptions"
                                    track-by="value"
                                    label="text"
                                    :multiple="false"
                                    placeholder="Search Speciality"
                                    @input="onFilterChange"
                                >
                                    <span slot="noResult">No speciality found</span>
                                </multiselect>
                            </div>
                            <div class="col-md-3">
                                <div class="all-tabs">
                                    <template>
                                        <div class="d-flex align-items-center justify-content-md-end">
                                            <span
                                                v-if="hasActiveFilters"
                                                class="edit-btn badge badge-secondary p-2 mr-2"
                                                @click="clearFilters"
                                            >
                                                <span>Clear Filters</span>
                                            </span>
                                            <svg class="svg-inline--fa fa-table mx-2" height="16px" width="16px" aria-hidden="true"
                                                focusable="false" data-prefix="fa" data-icon="table" role="img"
                                                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
                                                <path fill="currentColor"
                                                d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z">
                                                </path>
                                            </svg>
                                            <span class="edit-btn badge badge-info p-2" @click="addPost">
                                                <span>Add Post</span>
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-2">
                            <b-table
                                :items="tableData"
                                :fields="fields"
                                bordered
                                striped
                                responsive="sm"
                                class="table-bordered table-hover"
                                tbody-tr-class="rowClass"
                                >

                                <template #cell(select)="row">
                                    <b-form-checkbox
                                        v-model="selectedRows"
                                        :value="row.item"
                                    ></b-form-checkbox>
                                </template>

                                <template #cell(post_image)="row">
                                    <img
                                    :src="row.item.post_image"
                                    width="80"
                                    height="80"
                                    style="object-fit: cover"
                                    />
                                </template>

                                <template #cell(description)="row">
                                    {{ row.item.description || '-' }}
                                </template>

                                <template #cell(city)="row">
                                    {{ row.item.city || '-' }}
                                </template>

                                <template #cell(speciality)="row">
                                    {{ row.item.speciality || '-' }}
                                </template>

                                <template #cell(actions)="row">
                                    <b-button
                                        size="sm"
                                        variant="info"
                                        @click="viewDetails(row.item)"
                                    >
                                        View Details
                                    </b-button>
                                </template>

                            </b-table>
                        </div>
                        <template v-if="totalRows > size">
                            <div class="data_paginate">
                                <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                                    
                                    <b-pagination
                                    v-model="page"
                                    :total-rows="totalRows"
                                    :per-page="size"
                                    first-number
                                    last-number
                                    @input="fetchGmbData"
                                    ></b-pagination>

                                </div>
                                <div class="form-inline navbar-search">
                                    <span class="mr-2">Go to a Particular Paginated Page :</span>
                                    <div class="input-group">
                                        <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                                        </b-form-input>
                                        <div class="input-group-append">
                                        <button class="btn btn-search" @click="filterPage">
                                            <i class="fas fa-search fa-sm"> </i>
                                        </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <b-modal
                            id="bvModal"
                            ref="modal"
                            title="GMB Post Details"
                            @ok="handleWorkplaces"
                            @cancel="closeModal"
                            v-model="is_post_modal"
                            no-close-on-backdrop
                            centered
                            hide-header-close
                            ok-title="Add GMB Post"
                            cancel-title="Close"
                            size="xl"
                            >
                            <form ref="form" @submit.stop.prevent="handleSubmitPost">
                                <div class="row">

                                    <b-form-group class="col-12">
                                        <label>Post Image <span style="color:red">*</span></label>
                                        <b-form-file
                                            id="post_image"
                                            accept="image/png, image/jpeg, image/jpg"
                                            placeholder="Choose a file or drop it here..."
                                            @change="readFile($event, 'post_image')"
                                            ref="post_image"
                                        >
                                        </b-form-file>

                                        <div v-if="form.post_image_url" class="mt-2">
                                            <img :src="form.post_image_url"
                                                width="128px"
                                                height="128px"
                                                style="object-fit: contain; margin-top: 5px"
                                                class="edit-btn"
                                            />
                                        </div>
                                    </b-form-group>

                                    <b-form-group class="col-12">
                                        <label>Description </label>
                                        <b-form-textarea
                                            v-model="form.description"
                                            placeholder="Enter description"
                                            rows="4"
                                        ></b-form-textarea>
                                    </b-form-group>

                                </div>
                            </form>
                        </b-modal>

                        <b-modal
                            id="performanceModal"
                            v-model="is_performance_modal"
                            title="GMB Performance Details"
                            size="xl"
                            centered
                            scrollable
                            hide-footer
                        >
                            <div class="period-dropdown mb-4" ref="periodWrap">
                                <button type="button" class="period-trigger" @click="togglePeriod">
                                    <i class="far fa-calendar-alt period-cal"></i>
                                    <span class="period-texts">
                                        <span class="period-label">Time period</span>
                                        <span class="period-value">{{ rangeLabel }}</span>
                                    </span>
                                    <i class="fas period-caret" :class="periodOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                </button>

                                <div v-if="periodOpen" class="period-panel">
                                    <div class="period-field">
                                        <i class="far fa-calendar-alt period-cal"></i>
                                        <span class="period-texts">
                                            <span class="period-label">Time period</span>
                                            <span class="period-value">{{ pendingLabel }}</span>
                                        </span>
                                    </div>

                                    <div class="period-months">
                                        <button
                                            v-for="opt in periodOptions"
                                            :key="opt.value"
                                            type="button"
                                            class="period-pill"
                                            :class="pillClass(opt)"
                                            @click="selectPill(opt)"
                                        >{{ opt.text }}</button>
                                    </div>

                                    <div class="period-actions">
                                        <button type="button" class="btn btn-link btn-sm text-primary" @click="cancelPeriod">Cancel</button>
                                        <button type="button" class="btn btn-primary btn-sm" @click="applyPeriod">Apply</button>
                                    </div>
                                </div>
                            </div>

                            <template v-if="performance && performance.locations && performance.locations.length">
                                <div
                                    v-for="(loc, idx) in performance.locations"
                                    :key="idx"
                                    class="mb-4"
                                >
                                    <div class="d-flex flex-wrap align-items-center mb-3">
                                        <h5 class="mb-0 mr-3">{{ loc.name }}</h5>
                                        <span v-if="loc.city" class="badge badge-secondary mr-2 p-2">{{ loc.city }}</span>
                                        <span class="badge badge-warning mr-2 p-2">★ {{ loc.average_rating }}</span>
                                        <span class="badge badge-info mr-2 p-2">{{ loc.total_reviews }} Reviews</span>
                                        <a
                                            v-if="loc.google_qr_url"
                                            :href="loc.google_qr_url"
                                            target="_blank"
                                            rel="noopener"
                                            class="ml-auto"
                                        >
                                            View on Google
                                        </a>
                                    </div>

                                    <p class="text-muted small mb-2" v-if="performance.from && performance.to">
                                        Total from {{ performance.from }} to {{ performance.to }}
                                    </p>

                                    <div class="row">
                                        <div
                                            v-for="m in metricKeys"
                                            :key="m.label"
                                            class="col-md-4 col-6 mb-3"
                                        >
                                            <div class="card text-center h-100 border stat-card">
                                                <div class="card-body py-4">
                                                    <h3 class="stat-value mb-2">{{ metricTotal(loc, m) }}</h3>
                                                    <small class="stat-label text-muted">{{ m.label }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <p class="text-center text-muted my-4">No performance data available.</p>
                            </template>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main"
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { gmb } from "../../../js/path";
import axios from "axios";

export default {
    data () {
        return {
            title: "List GMB",
            items: [
                {
                    text: "Home",
                    href: "/",
                },
                {
                    text: "List",
                },
            ],
            tableData: [],
            selectedRows: [],
            filter: "",
            cityFilter: null,
            specialityFilter: null,
            cityOptions: [],
            specialityOptions: [],
            debounceTimer: null,
            page: 1,
            size: 20,
            pageNo: "",
            totalRows: 0,
            fields: [
                { key: "select", label: "" },
                // {
                //     key: "id",
                //     label: "ID",
                //     sortable: true,
                // },
                {
                    key: "business_name",
                    label: "Business Name",
                },
                {
                    key: "city",
                    label: "City",
                },
                {
                    key: "speciality",
                    label: "Speciality",
                },
                {
                    key: "location_id",
                    label: "Location ID",
                },
                {
                    key: "actions",
                    label: "Action",
                }
            ],
            metricKeys: [
                { key: "views", label: "Total Views" },
                { key: "website_clicks", label: "Total Clicks" },
                { key: "total_engagements", label: "Total Engagement" }
            ],
            is_performance_modal: false,
            performance: null,
            performanceLocationId: null,
            filters: {
                from_month: null,
                from_year: null,
                to_month: null,
                to_year: null
            },
            selectedFrom: null,
            selectedTo: null,
            periodOptions: [],
            periodOpen: false,
            pendingFrom: null,
            pendingTo: null,
            is_post_modal: false,
            post_image_url: "",
            post_image: "",
            form: {
                post_image: "",
                description: "",
                post_image_url: ""
            },
            gmbUrl:
                process.env.VUE_APP_ENV == "development"
                ? "https://ai-dev.mymedisage.com/api"
                : process.env.VUE_APP_ENV == "staging"
                ? "https://ai-stage.mymedisage.com/api"
                : process.env.VUE_APP_ENV == "production"
                ? "https://ai-prod.mymedisage.com/api"
                : "https://ai-dev.mymedisage.com/api", 
        }
    },
    components: {
        Layout,
        PageHeader,
        Multiselect
    },
    methods: {
        addPost() {
            this.resetForm();
            this.is_post_modal = true;
        },

        readFile(e, txt) {
            if (txt === "post_image") {
                const file = e.target.files[0];

                if (!file) return;

                if (file.size > 2 * 1000 * 1000) {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: "Uploaded File is More than 2MB",
                });

                this.$refs.post_image.reset();
                this.resetForm();
                return;
                }

                this.form.post_image = file;

                this.form.post_image_url = URL.createObjectURL(file);
            }
        },

        handleWorkplaces(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.handleSubmitPost();
        },

        async handleSubmitPost() {
            if (!this.form.post_image) {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: "Post image is required"
                });
                return;
            }

            const formData = new FormData();

            formData.append("image", this.form.post_image);

            // ✅ optional description
            if (this.form.description) {
                formData.append("summary", this.form.description);
            }

            if (this.selectedRows.length > 0) {
                const locationIds = this.selectedRows.map(item => item.location_id);
                formData.append("location_ids", JSON.stringify(locationIds));
            }

            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1]);
            }
            this.$store.commit("loader/updateStatus", true);
            try {
                console.log(this.gmbUrl);
                console.log('username',process.env.VUE_APP_API_AI_USERNAME);
                console.log('password', process.env.VUE_APP_API_AI_PASSWORD);
                
                // ✅ API call
                const res = await axios.post(
                    `${this.gmbUrl}/gmb/create-post`,
                formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        auth: {
                            username: process.env.VUE_APP_API_AI_USERNAME,
                            password: process.env.VUE_APP_API_AI_PASSWORD
                        }
                    }
                );

                console.log("API RESPONSE:", res.data);

                // ✅ success UI
                this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "success",
                title: "Post created successfully"
                });

                this.is_post_modal = false;
                this.resetForm();
                this.selectedRows = [];

            } catch (err) {
                console.error("ERROR:", err);

                this.$store.commit("toast/updateStatus", {
                status: true,
                icon: "error",
                title: err.response?.data?.message || "Upload failed"
                });
            }
            this.$store.commit("loader/updateStatus", false);
        },

        resetForm() {
            this.form = {
                post_image: null,
                description: "",
                post_image_url: ""
            };

            if (this.$refs.post_image) {
                this.$refs.post_image.reset();
            }
        },

        closeModal() {
            this.resetForm();
        },

        viewDetails(item) {
            const locationId = String(item.location_id || "").replace("locations/", "");

            if (!locationId) {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: "Location ID not found",
                });
                return;
            }

            this.performanceLocationId = locationId;
            this.performance = null;
            this.periodOptions = [];
            this.selectedFrom = null;
            this.selectedTo = null;
            this.filters = { from_month: null, from_year: null, to_month: null, to_year: null };

            this.is_performance_modal = true;
            // initial load: no range -> API returns its default months
            this.fetchPerformance(true);
        },

        syncFiltersFromSelection() {
            const [fromYear, fromMonth] = this.selectedFrom.split("-").map(Number);
            const [toYear, toMonth] = this.selectedTo.split("-").map(Number);
            this.filters = {
                from_month: fromMonth,
                from_year: fromYear,
                to_month: toMonth,
                to_year: toYear
            };
        },

        togglePeriod() {
            this.periodOpen = !this.periodOpen;
            if (this.periodOpen) {
                // start editing from the currently applied range
                this.pendingFrom = this.selectedFrom;
                this.pendingTo = this.selectedTo;
            }
        },

        periodIndex(value) {
            return this.periodOptions.findIndex((o) => o.value === value);
        },

        valueLabel(value) {
            const opt = this.periodOptions.find((o) => o.value === value);
            return opt ? opt.text : "";
        },

        selectPill(opt) {
            // no start yet, or a full range already picked -> begin a new selection
            if (!this.pendingFrom || (this.pendingFrom && this.pendingTo)) {
                this.pendingFrom = opt.value;
                this.pendingTo = null;
                return;
            }

            // pick the second endpoint, keeping chronological order
            if (this.periodIndex(opt.value) < this.periodIndex(this.pendingFrom)) {
                this.pendingTo = this.pendingFrom;
                this.pendingFrom = opt.value;
            } else {
                this.pendingTo = opt.value;
            }
        },

        pillClass(opt) {
            const i = this.periodIndex(opt.value);
            const fromI = this.pendingFrom ? this.periodIndex(this.pendingFrom) : -1;
            const toI = this.pendingTo ? this.periodIndex(this.pendingTo) : -1;

            if (opt.value === this.pendingFrom || opt.value === this.pendingTo) {
                return "is-active";
            }
            if (fromI > -1 && toI > -1 && i > fromI && i < toI) {
                return "is-in-range";
            }
            return "";
        },

        applyPeriod() {
            if (!this.pendingFrom) {
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: "Please select a time period",
                });
                return;
            }

            this.selectedFrom = this.pendingFrom;
            this.selectedTo = this.pendingTo || this.pendingFrom;
            this.syncFiltersFromSelection();
            this.periodOpen = false;
            this.fetchPerformance();
        },

        cancelPeriod() {
            this.periodOpen = false;
        },

        handleOutsideClick(e) {
            if (
                this.periodOpen &&
                this.$refs.periodWrap &&
                !this.$refs.periodWrap.contains(e.target)
            ) {
                this.periodOpen = false;
            }
        },

        buildPeriodOptionsFromLabels(labels) {
            const monthMap = {
                Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
                Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
            };

            this.periodOptions = (labels || []).map((lbl) => {
                const [mon, yr] = String(lbl).split(" ");
                return { value: `${yr}-${monthMap[mon]}`, text: lbl };
            });

            // reflect the full range returned by the API
            if (this.periodOptions.length) {
                this.selectedFrom = this.periodOptions[0].value;
                this.selectedTo = this.periodOptions[this.periodOptions.length - 1].value;
                this.syncFiltersFromSelection();
            }
        },

        async fetchPerformance(isDefault = false) {
            if (!this.performanceLocationId) return;

            const params = new URLSearchParams({
                location_id: this.performanceLocationId
            });

            // only send the range once the user has picked one; the default call
            // lets the API return its own default months
            if (!isDefault && this.filters.from_month) {
                params.append("from_month", this.filters.from_month);
                params.append("from_year", this.filters.from_year);
                params.append("to_month", this.filters.to_month);
                params.append("to_year", this.filters.to_year);
            }

            this.$store.commit("loader/updateStatus", true);

            try {
                const res = await axios.get(
                    `${gmb.gmbUsersPerformanceUrl}?${params.toString()}`
                );

                if (res.data && res.data.status) {
                    this.performance = res.data.data;
                    if (isDefault) {
                        this.buildPeriodOptionsFromLabels(this.performance.month_labels);
                    }
                } else {
                    this.performance = null;
                    this.$store.commit("toast/updateStatus", {
                        status: true,
                        icon: "error",
                        title: res.data?.message || "Failed to load performance",
                    });
                }
            } catch (err) {
                console.error(err);
                this.performance = null;
                this.$store.commit("toast/updateStatus", {
                    status: true,
                    icon: "error",
                    title: "Failed to load performance",
                });
            }

            this.$store.commit("loader/updateStatus", false);
        },

        metricValue(stats, m) {
            if (!stats) return 0;
            if (m.keys) {
                return m.keys.reduce((sum, k) => sum + (Number(stats[k]) || 0), 0);
            }
            return Number(stats[m.key]) || 0;
        },

        metricTotal(loc, m) {
            return this.monthOrder(loc).reduce((sum, month) => {
                const stats = loc.monthly_stats && loc.monthly_stats[month];
                return sum + this.metricValue(stats, m);
            }, 0);
        },

        monthOrder(loc) {
            if (this.performance && Array.isArray(this.performance.month_labels) && this.performance.month_labels.length) {
                return this.performance.month_labels;
            }
            return Object.keys((loc && loc.monthly_stats) || {});
        },

        async fetchGmbData() {
            let url = `${gmb.gmbUrl}?page=${this.page}&size=${this.size}`;

            if (this.filter) {
                url += `&search=${encodeURIComponent(this.filter)}`;
            }
            if (this.cityFilter && this.cityFilter.value) {
                url += `&city=${encodeURIComponent(this.cityFilter.value)}`;
            }
            if (this.specialityFilter && this.specialityFilter.value) {
                url += `&speciality=${encodeURIComponent(this.specialityFilter.value)}`;
            }

            this.$store.commit("loader/updateStatus", true);

            try {
                const res = await axios.get(url);
                const data = res.data;

                if (data.status) {
                    this.tableData = data.data;
                    this.totalRows = data.pagination.total;
                    this.setFilterOptions(data.filters);
                }

            } catch (err) {
                console.error(err);
            }

            this.$store.commit("loader/updateStatus", false);
        },

        setFilterOptions(filters) {
            if (!filters) return;

            this.cityOptions = (filters.cities || []).map((c) => ({ value: c, text: c }));
            this.specialityOptions = (filters.specialities || []).map((s) => ({ value: s, text: s }));
        },

        onFilterChange() {
            this.page = 1;
            this.fetchGmbData();
        },

        clearFilters() {
            this.filter = "";
            this.cityFilter = null;
            this.specialityFilter = null;
            this.page = 1;
            this.fetchGmbData();
        },

        onSearchInput() {
            clearTimeout(this.debounceTimer);

            this.debounceTimer = setTimeout(() => {
            this.page = 1;
            this.fetchGmbData();
            }, 500);
        },
        searchFor() {
            this.page = 1;
            this.fetchGmbData();
        },
        filterPage() {
            const pageNumber = parseInt(this.pageNo);

            if (!pageNumber || pageNumber < 1) {
                alert("Enter valid page number");
                return;
            }

            const totalPages = Math.ceil(this.totalRows / this.size);

            if (pageNumber > totalPages) {
                alert(`Max page is ${totalPages}`);
                return;
            }

            this.page = pageNumber;

            this.fetchGmbData();
        }
    },
    computed: {
        hasActiveFilters() {
            return !!(this.filter || this.cityFilter || this.specialityFilter);
        },
        rangeLabel() {
            if (!this.selectedFrom || !this.selectedTo) return "Select period";
            const from = this.valueLabel(this.selectedFrom);
            const to = this.valueLabel(this.selectedTo);
            return from === to ? from : `${from} – ${to}`;
        },
        pendingLabel() {
            if (!this.pendingFrom) return "Select period";
            const from = this.valueLabel(this.pendingFrom);
            if (!this.pendingTo) return from;
            const to = this.valueLabel(this.pendingTo);
            return from === to ? from : `${from} – ${to}`;
        }
    },
    watch: {
        page(newVal) {
            this.pageNo = newVal;
        }
    },
    async mounted(){
        document.addEventListener("click", this.handleOutsideClick);

        const queryLocationId = this.$route.query.location_id;

        // wait for the list load to finish so both calls don't toggle the shared loader
        await this.fetchGmbData();

        // auto-open the performance dashboard when linked in with ?location_id=...
        if (queryLocationId) {
            this.viewDetails({ location_id: queryLocationId });
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleOutsideClick);
    }
}
</script>

<style scoped>
/* performance totals cards */
.stat-card {
    border-radius: 12px;
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
    cursor: default;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(31, 45, 61, 0.12);
    border-color: #4c7cf3 !important;
}

.stat-value {
    font-size: 2rem;
    font-weight: 700;
    color: #1f2d3d;
}

.stat-label {
    font-size: 0.95rem;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.period-dropdown {
    position: relative;
    max-width: 340px;
}

/* trigger + field share the same bordered look */
.period-trigger,
.period-field {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: left;
    background: #fff;
    border: 1px solid #d3daf2;
    border-radius: 10px;
    padding: 10px 14px;
    gap: 12px;
}

.period-trigger {
    cursor: pointer;
}

.period-trigger:focus {
    outline: none;
    border-color: #4c7cf3;
    box-shadow: 0 0 0 2px rgba(76, 124, 243, 0.15);
}

.period-cal {
    color: #4c7cf3;
    font-size: 16px;
}

.period-texts {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    flex: 1;
}

.period-label {
    font-size: 11px;
    color: #4c7cf3;
}

.period-value {
    font-size: 15px;
    font-weight: 600;
    color: #1f2d3d;
}

.period-caret {
    color: #6b7280;
    font-size: 12px;
}

/* popover panel */
.period-panel {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 20;
    width: 360px;
    max-width: 90vw;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 12px 40px rgba(31, 45, 61, 0.18);
    padding: 16px;
}

.period-field {
    margin-bottom: 16px;
}

.period-months {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.period-pill {
    border: none;
    border-radius: 999px;
    padding: 10px 8px;
    font-size: 14px;
    font-weight: 500;
    color: #4c7cf3;
    background: #eef2fe;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.period-pill:hover {
    background: #dde5fd;
}

.period-pill.is-in-range {
    background: #dbe4fd;
    color: #2f5bd6;
}

.period-pill.is-active {
    background: #4c7cf3;
    color: #fff;
}

.period-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
}
</style>